









import { Component, Prop, Vue } from 'vue-property-decorator';
import GoogleMapsApiLoader from 'google-maps-api-loader';

@Component
export default class Gmap extends Vue {
	@Prop({ default: {}, required: true }) private mapConfig;

	$refs!: {
		googleMap;
	};

	private google = new GoogleMapsApiLoader();
	private map = null;

	async mounted() {
		const googleMapApi = await GoogleMapsApiLoader({
			apiKey: process.env.MAPS_API_KEY,
		});
		this.google = googleMapApi;
		this.initializeMap();
	}

	initializeMap() {
		const mapContainer = this.$refs.googleMap;
		this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
	}
}
